<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1 v-if="store.id">
          {{ $t('editModel', { model: $tc('models.store', 1) }) }}
        </h1>
        <h1 v-else>
          {{ $t('createModel', { model: $tc('models.store', 1) }) }}
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-form @submit.prevent="submit">
          <v-card class="mt-4">
            <v-card-text>
              <v-container fluid grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md6>
                    <v-select v-model="provider"
                              :items="storeProviders"
                              item-value="id"
                              item-text="name"
                              :label="$tc('models.provider')"
                              ></v-select>
                  </v-flex>

                  <v-flex xs12 sm12 md6>
                    <v-text-field v-model="store.shop"
                                  name="shop"
                                  :label="$t('attrs.shop_url')"
                                  v-validate="'required|uniqueStore'"
                                  :error-messages="errors.collect('shop')"
                                  data-vv-name="shop"
                                  :data-vv-as="$t('attrs.shop_url')"
                                  required
                                  ></v-text-field>
                  </v-flex>

                  <Woocommerce v-if="isWooCommerce" :store="store" :address="address"></Woocommerce>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="back" :loading="loading" :disabled="loading">{{ $t('cancel') }}</v-btn>
              <v-btn color="primary" dark :loading="loading" :disabled="loading" type="submit">{{ $t('save') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Store from '@/client/store'

import Woocommerce from '@/components/stores/woocommerce'

import { Validator } from 'vee-validate';

export default {
  name: 'StoreFormView',

  props: {},

  data () {
    return {
      loading: false,
      storeProviders: [
        { id: 'shopify', name: 'Shopify' },
        { id: 'woocommerce', name: 'WooCommerce' },
        { id: 'tiendanube', name: 'Tienda Nube' }
      ],
      provider: 'shopify',
      store: {},
      address: {},
      stores: []
    }
  },

  components: {
    Woocommerce
  },

  computed: {
    isWooCommerce () {
      return this.provider === 'woocommerce'
    },
  },

  methods: {
    async submit () {
      if(this.provider != "tiendanube"){
        const isValid = await this.$validator.validateAll()
        if (!isValid) { return }
      }
      this.loading = true
      try {
        this.store.shop = this.store.shop
        this.store.provider = this.provider
        this.store.woocommerce_address = { ...this.address }
        const data = await this.store.save()
        if (data.params && data.params.url) {
          const url = data.params.url
          window.location.href = url.replace('%23', '')
        } else if ( typeof(data) == 'string' ) {
          //shopify redirect
          window.location.href = data
        } else {
          this.setNotification({
            color: 'success',
            message: this.$t('successfullySavedNotification')
          })
          this.back()
        }
      } catch (err) {
        this.handleErr(err)
      }
      this.loading = false
    },

    formatShopUrl(url) {
      return url.replace(/https:\/\/|http:\/\//,'')
    }
  },

  watch: {
  },

  async mounted () {
    this.stores = await Store.all()

    Validator.extend('uniqueStore', {
      getMessage: () => this.$t('invalidShopUrl'),
      validate: value => {
        return this.stores.find(store => this.formatShopUrl(store.params.shop) == this.formatShopUrl(value)) ? false : true
      }
    })

    this.store = new Store({
      provider: 'shopify',
      shop: '',
      hmac: '',
      code: '',
      timestamp: '',
      api_key: '',
      api_secret: '',
      woocommerce_version: '3',
      woocommerce_legacy_api: false,
      woocommerce_address: {}
    })
  }
}
</script>
